/**
 * PublishModalWarnings — non-blocking notices above the publish modal's
 * actions (BON-469). Distinct from `Blockers`: these do NOT disable Confirm.
 * The 6-week lead time lives here — a scheduling nudge the operator may
 * knowingly publish past, not an invariant.
 *
 * Warn-coloured rather than error-coloured so the difference between "you
 * cannot" and "are you sure" is visible at a glance.
 */
export function Warnings({ messages }: { messages: string[] }) {
  if (messages.length === 0) return null;
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        padding: '10px 12px',
        borderRadius: 10,
        background: 'var(--nb-warn-soft)',
        border: '1px solid var(--nb-warn)',
      }}
    >
      <span
        style={{ fontSize: 11, fontWeight: 800, letterSpacing: '.04em', color: 'var(--nb-warn)' }}
      >
        PUBLISH ANYWAY?
      </span>
      {messages.map((m) => (
        <span key={m} style={{ fontSize: 12.5, color: 'var(--nb-ink-2)', lineHeight: 1.45 }}>
          {m}
        </span>
      ))}
    </div>
  );
}
